import { merge } from 'lodash';
import { StyleParamType, wixColorParam, createStylesParams } from '@wix/tpa-settings';
import backgroundStylesParams from './Tabs/Design/Background/styles-params';
import textsStylesParams from './Tabs/Design/Texts/styles-params';
import buttonLinksStylesParams from './Tabs/Design/ButtonLinks/styles-params';
import displayStylesParams from './Tabs/Display/styles-params';

type IPaletteStylesParams = {
  disabledColor: StyleParamType.Color;
  textColorLow: StyleParamType.Color;
  textColor: StyleParamType.Color;
};

const paletteStylesParams = createStylesParams<IPaletteStylesParams>({
  disabledColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-3'),
  },
  textColorLow: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-4'),
  },
  textColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
});

const stylesParams = merge(
  paletteStylesParams,
  backgroundStylesParams,
  textsStylesParams,
  buttonLinksStylesParams,
  displayStylesParams,
);

export default stylesParams;
